import { render, staticRenderFns } from "./AllNews.vue?vue&type=template&id=9efa6822&scoped=true"
import script from "./AllNews.vue?vue&type=script&lang=js"
export * from "./AllNews.vue?vue&type=script&lang=js"
import style0 from "./AllNews.vue?vue&type=style&index=0&id=9efa6822&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9efa6822",
  null
  
)

export default component.exports